import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { allPaths } from '../../routes/Paths';
import { UserContext } from '../../contexts/UserContext';
import { LoginFormHeader } from '../atoms';

const LogoutPage = () => {
  const navigate = useNavigate();

  const { loginData, logOut, user } = useContext(UserContext);

  useEffect(() => {
    (async () => {
      await logOut();

      if (!loginData.session && user.userType === 'unknown') {
        navigate(allPaths.LOGIN.path);
      }
    })();
  }, [loginData, user]);

  return (
    <div>
      <LoginFormHeader>
        <h1>Logging You Out</h1>
      </LoginFormHeader>
    </div>
  );
};

export { LogoutPage };
